import {FaPrint} from "react-icons/fa6";
import Button from "../../../components/button/button";
import {Card} from "../../../components/card/card";
import {Template} from "../../../components/template/template";
import {useLicensingQuery} from "./components/use-licensing-query";
import LicensingDetails from "./components/licensing-tab";
import PrintTemplate from "../../../components/reports/print-reports/print-template.jsx";
import {useEffect, useRef, useState} from "react";

const API_URL = import.meta.env.VITE_API_URL;
export default function Licensing() {
    const [loading, setLoading] = useState(false)
    const {data, isLoading, isError} = useLicensingQuery();
    const reportTitle = "Licenciamento";

    useEffect(() => {
        setLoading(isLoading)
    }, [isLoading]);

    const entity = data?.entity ?? {};
    const licenseDetails = data?.licenseDetails ?? {};

    const entityForPrint = {
        ...entity,
        imagePath: entity?.imagePath || API_URL + `/corporation/entity/image`,
    }

    const printComponentRef = useRef(null);

    return (
        <>
            <Template isLoading={loading} className={"print:hidden"}>
                <Template.Header>
                    <Template.Title>Licenciamento</Template.Title>
                    <Button title="Imprimir" disabled={isLoading || isError} onClick={() => printComponentRef.current?.print()}><FaPrint/></Button>
                </Template.Header>
                <Template.Body>
                    <div>
                        <Card>
                            <Card.Header>
                                <Card.Title>Detalhes do licenciamento</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {isLoading && <div>Carregando...</div>}
                                {isError && <div>Erro ao carregar licenciamento.</div>}
                                {!isLoading && !isError && (
                                    <PrintTemplate
                                        ref={printComponentRef}
                                        entity={entityForPrint}
                                        title={reportTitle}
                                        printHeaderClassname={"hidden print:block"}
                                        setIsPrinting={setLoading}
                                    >
                                        <LicensingDetails entity={entity} licenseDetails={licenseDetails}/>
                                    </PrintTemplate>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                </Template.Body>
            </Template>
        </>
    )
}